<app-navbar-small></app-navbar-small>
<div class="m-lg-4"><div class="row d-flex justify-content-center">
  <h2 style="color: #0D446E"><b>Predictions by GH-EFDT</b></h2>
</div></div>
<table mdbTable striped="true">
  <thead>
  <tr>
    <th *ngFor="let head of headElements" scope="col">{{head}} </th>
  </tr>
  </thead>
  <div *ngIf="(items | async)?.length==0">
    <p class="container -align-center">No records are available!</p></div>
  <tbody>
  <tr mdbTableCol *ngFor="let item of items | async">
    <td>{{item.meanOfTheIntegratedProfile}}</td>
    <td>{{item.standardDeviationOfTheIntegratedProfile}}</td>
    <td>{{item.excessKurtosisOfTheIntegratedProfile}}</td>
    <td>{{item.skewnessOfTheIntegratedProfile}}</td>
    <td>{{item.meanOfTheDMSNRCurve}}</td>
    <td>{{item.standardDeviationOfTheDMSNRCurve}}</td>
    <td>{{item.excessKurtosisOfTheDMSNRCurve}}</td>
    <td>{{item.skewnessOfTheDMSNRCurve}}</td>
    <td>{{item.yPred}}</td>
    <td>
      <mdb-icon fas icon="check-circle" size="2x" class="teal-text mx-sm-1" (click)="verifyItemCorrect(item.key)">
      </mdb-icon><mdb-icon fas icon="times-circle" size="2x" class="pink-text mx-sm-1" (click)="verifyItemWrong(item.key)"></mdb-icon>
    </td>

    <td class="mdb-color lighten-3">{{item.targetClass}}</td>
    <td>{{item.key}}</td>
  </tr>
  </tbody>
</table>

<button *ngIf="(items | async)?.length!=0" mdbBtn type="button" class="white-text m-sm-3" rounded="true" mdbWavesEffect style="background-color: #0D446E" (click)="verifyAll()">Verify all</button>


